
import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PatientTableRow } from "./PatientTableRow";

interface Patient {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  created_at: string;
  lastTriage?: {
    urgency: string;
    created_at: string;
    symptoms: string[];
  };
  nextAppointment?: {
    start_time: string;
  };
}

interface PatientTableProps {
  patients: Patient[];
  onViewPatient: (patientId: string) => void;
}

export function PatientTable({ patients, onViewPatient }: PatientTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Patient</TableHead>
          <TableHead>Contact</TableHead>
          <TableHead>Last Triage</TableHead>
          <TableHead>Next Appointment</TableHead>
          <TableHead>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {patients.map((patient) => (
          <PatientTableRow
            key={patient.id}
            patient={patient}
            onViewPatient={onViewPatient}
          />
        ))}
      </TableBody>
    </Table>
  );
}
